import locale from "localization/en";

export const varianceAdjustmentColumn = [
  { key: "adjustmentType", text: locale.adjustmentType },
  {
    key: "productPumpNumber",
    text: (
      <span>
        {locale.product} /<br />
        {locale.pumpNumber}
      </span>
    ),
  },
  { key: "quantity", text: locale.quantity },
  { key: "amount", text: locale.amount },
  { key: "discount", text: locale.totalDiscount },
  { key: "finalAmountPaid", text: locale.finalAmountPaid },
  {
    key: "paymentMethodRefNo",
    text: (
      <span>
        {locale.paymentMethod} /<br />
        {locale.referenceNo}
      </span>
    ),
  },
  {
    key: "createdByDateTime",
    text: (
      <span>
        {locale.createdBy} /<br />
        {locale.dateAndTime}
      </span>
    ),
  },
];
